/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';

/**
 * 
 * @export
 * @interface PaginatedDomainList
 */
export interface PaginatedDomainList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDomainList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDomainList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDomainList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Domain>}
     * @memberof PaginatedDomainList
     */
    results: Array<Domain>;
}

/**
 * Check if a given object implements the PaginatedDomainList interface.
 */
export function instanceOfPaginatedDomainList(value: object): value is PaginatedDomainList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDomainListFromJSON(json: any): PaginatedDomainList {
    return PaginatedDomainListFromJSONTyped(json, false);
}

export function PaginatedDomainListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDomainList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(DomainFromJSON)),
    };
}

  export function PaginatedDomainListToJSON(json: any): PaginatedDomainList {
      return PaginatedDomainListToJSONTyped(json, false);
  }

  export function PaginatedDomainListToJSONTyped(value?: PaginatedDomainList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DomainToJSON)),
    };
}

